import {
  ChatMessage,
  DATE_SEPARATOR_PREFIX,
  ReservedMessageIds
} from "./types";

export const isSameLastChatMessage = (
  aMsgs: ChatMessage[],
  bMsgs: ChatMessage[]
) => {
  const lastAMessage = aMsgs ? aMsgs[aMsgs.length - 1] : null;
  const lastBMessage = bMsgs ? bMsgs[bMsgs.length - 1] : null;
  if (lastAMessage && lastBMessage) {
    return lastAMessage.id === lastBMessage.id;
  }
  return false;
};

// The spinner bubble: Dreamer answering a question.
export const isThinkingMessage = (message: ChatMessage): boolean =>
  message.id === ReservedMessageIds.WAITING_MSG;

export const isReservedMessage = (message: ChatMessage): boolean => {
  return (
    message.id === ReservedMessageIds.MSG_SEPARATOR ||
    isThinkingMessage(message)
  );
};

export const isDateSeparatorMessage = (message: ChatMessage): boolean => {
  return message.id?.startsWith(DATE_SEPARATOR_PREFIX) ?? false;
};

export const findDraftMessageIndex = (
  messages: ChatMessage[],
  draftId: string
): number =>
  messages.findIndex((message) => message.emailDraft?.draftId === draftId);
